import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  standalone: true,
  imports: [MatCardModule],
  selector: 'app-vbox',
  styleUrls: ['./vbox.component.scss'],
  template: `
    <mat-card appearance="outlined">
      <mat-card-header>
        <mat-card-title>{{ titleText }}</mat-card-title>
        <ng-content select="[bar-item-right]"></ng-content>
      </mat-card-header>
      <mat-card-content>
        <ng-content select="[content]"></ng-content>
      </mat-card-content>
    </mat-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VBoxComponent {
  @Input() titleText: string;
}
